import React from "react"
import './styles.scss';

const PropertyContentNav = (props) => {
    const property = props.property;
    const modal = props.modal;

    let galleryNavItem;
    let descriptionNavItem;
    let videoNavItem;
    let trailcamNavItem;
    let auctionNavItem;
    let featuresNavItem;
    let landDetailsNavItem;
    let buildingDetailsNavItem;
    let mapNavItem;
    let documentsNavItem;
    let resourcesNavItem;
    let aerialNavItem;
    let faqsNavItem;
    let virtualTours;

    if(!modal && property.images && property.images.length > 0){
        galleryNavItem = (
            <div className="nav-item gallery">
                <a href="#gallery" data-section="gallery">Gallery</a>
            </div>
        )
    }


    // Property Description
    if(property.summary){
        descriptionNavItem = (
            <div className="nav-item description">
                <a href="#description" data-section="description">About this Property</a>
            </div>
        )
    }

    // Property Video
    if(property.property_video){
        videoNavItem = (
            <div className="nav-item video">
                <a href="#video" data-section="video">Video</a>
            </div>
        )
    }

    // Auction Info
    if(property.is_auction){
        auctionNavItem = (
            <div className="nav-item auction">
                <a href="#auction" data-section="auction">Auction</a>
            </div>

        )
    }

    // No conditional on Features
    featuresNavItem = (
        <div className="nav-item features">
            <a href="#features" data-section="features">Features</a>
        </div>

    )

    // No conditionals on land
    landDetailsNavItem = (
        <div className="nav-item land-details">
            <a href="#land-details" data-section="land-details">Land Details</a>
        </div>

    )

    // No conditionals on Building Details
    buildingDetailsNavItem = (
        <div className="nav-item building-details">
            <a href="#building-details" data-section="building-details">Building Details</a>
        </div>

    )

    // Porperty Map
    if(property.pin_location || property.embedded_map_link){
        mapNavItem = (
            <div className="nav-item map">
                <a href="#map" data-section="map">Map</a>
            </div>

        )
    }

    // Documents
    if(property.documents && property.documents.length >=1){
        documentsNavItem = (
            <div className="nav-item documents">
                <a href="#documents" data-section="documents">Documents</a>
            </div>
        )
    }

    // Resources
    if(property.resource_links && property.resource_links.length >=1){
        resourcesNavItem = (
            <div className="nav-item resources">
                <a href="#resources" data-section="resources">Resources</a>
            </div>
        )
    }

    // Aerial Video? Map?
    // Not sure what this is supposed to contain
    if(property.aerial){
        aerialNavItem = (
            <div className="nav-item aerial">
                <a href="#aerial" data-section="aerial">Aerial View</a>
            </div>
        )
    }

    // Property FAQs
    if(property.frequently_asked_questions && property.frequently_asked_questions.length > 0){
        faqsNavItem = (
            <div className="nav-item faqs">
                <a href="#faqs" data-section="faqs">FAQs</a>
            </div>
        )
    }

    // Trailcam photos
    if(property.trailcam_images){
        trailcamNavItem = (
            <div className="nav-item trailcam">
                <a href="#trailcam" data-section="trailcam">Trailcam Photos</a>
            </div>
        )
    }

  if(property.virtual_tour_link){
    virtualTours = (
      <div className="nav-item trailcam">
        <a href="#virtual-tours" data-section="virtual-tours">Virtual Tours</a>
      </div>
    )
  }

    $('.nav-item a').on('click', function (e) {
        e.preventDefault();
        var target = $(this.hash);
        if (modal) {
            $('.property-details-content-container').css('scroll-padding-top','70px')
            $('.property-details-content-container').css('scroll-behavior','smooth')
            document.getElementById(`${this.hash.replace('#','')}`).scrollIntoView(true)
        } else {
            $('html, body').animate({ scrollTop: target.offset().top - 175 }, 0);
        }

    });

    return (

        <div className={`property-nav ${modal ? 'is-modal' : ''}`}>
            <div className={`property-nav ${modal ? '' : 'container p-0'}`}>
                <div className="scroll">
                    {auctionNavItem}
                    {galleryNavItem}
                    {videoNavItem}
                    {mapNavItem}
                    {descriptionNavItem}
                    {featuresNavItem}
                    {landDetailsNavItem}
                    {buildingDetailsNavItem}
                    {resourcesNavItem}
                    {aerialNavItem}
                    {trailcamNavItem}
                    {faqsNavItem}
                    {documentsNavItem}
                    {virtualTours}
                </div>
            </div>
        </div>
    )
  }

  export default PropertyContentNav